'use strict';

/*global app*/
/*global initialize*/
/*global doFilter*/
/*global services*/

function WarehouseService() {
  this.modal = null;

  this.init();
}

WarehouseService.prototype = $.extend({}, {
  constructor: 'WarehouseService',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    $('body').on('click', '.warehouse__overview', function () {
      _this.showOverview();

      return false;
    });

    $('body').on('keyup', '.warehouse-overview__search-input', function () {
      _this.overviewSearch($(this).val());
      return false;
    });

    $('body').on('change', '.warehouse-overview__search-input', function () {
      _this.overviewSearch($(this).val());
      return false;
    });

    $('body').on('click', '.warehouse__show-article-dispositions', function () {
      _this.showArticleDispositions($(this).data('article_id'));

      return false;
    });

    $('body').on('click', '.warehouse__show-article-batches', function () {
      _this.showArticleBatches($(this).data('warehouse_id'), $(this).data('article_id'), $(this).data('tag'));

      return false;
    });

    $('body').on('click', '.warehouse__select-batch', function () {
      _this.selectBatch($(this).data('batch_property'));

      return false;
    });

    $('body').on('transfer-note-created transfer-note-mismatch-created release-note-created', function () {
      if (_this.modal.isOpen()) {
        _this.reloadOverview();
      }
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  showOverview: function showOverview(searchString) {
    var _this = this;

    var scrollTop = 0;
    if (!_this.modal.isOpen()) {
      _this.modal.open({
        height: 'auto',
        width: 'xl'
      });
    } else {
      scrollTop = _this.modal.contentDOM().closest('.modal').scrollTop();
    }

    _this.modal.block();
    app.get(app.path('warehouse_overview', { WorkplaceRID: app.param('workplace_rid') }), function (res) {
      _this.modal.unBlock();

      if (res.msg === 'SUCCESS') {
        //pokud jsem uplne nahore, volam content, ktery provede i focus
        _this.modal.content(res.data.html, scrollTop > 0);

        initialize(_this.modal.contentDOM());

        if (scrollTop) {
          _this.modal.contentDOM().closest('.modal').scrollTop(scrollTop);
        }

        if (searchString) {
          _this.overviewSearch(searchString);
        }
      } else if (res.msg === 'NOT_VALID') {
        app.viewWarningMessage();
      } else {
        app.viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  reloadOverview: function reloadOverview() {
    var _this = this;

    var searchString = _this.modal.contentDOM().find('.warehouse-overview__search-input').val();

    _this.showOverview(searchString);

    return _this;
  },

  overviewSearch: function overviewSearch(value) {
    var _this = this;

    _this.modal.contentDOM().find('.warehouse-overview__search-input').val(value);

    var $items = _this.modal.contentDOM().find('.warehouse-overview__items');
    doFilter($items, 'warehouse-item', value);

    return _this;
  },

  showArticleDispositions: function showArticleDispositions(articleId) {
    var _this = this;

    _this.modal.open({
      height: 'auto'
    });

    _this.modal.block();
    app.get(app.path('warehouse_dispositions', { ArticleId: articleId }), function (res) {
      _this.modal.unBlock();

      if (res.msg === 'SUCCESS') {
        _this.modal.content(res.data.html);
      } else if (res.msg === 'NOT_VALID') {
        app.viewWarningMessage();
      } else {
        app.viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  showArticleBatches: function showArticleBatches(warehouseId, articleId, tag) {
    var _this = this;

    _this.modal.open({
      height: 'auto'
    });

    _this.modal.block();
    app.get(app.path('warehouse_batches', { WarehouseId: warehouseId, ArticleId: articleId }), function (res) {
      _this.modal.unBlock();

      if (res.msg === 'SUCCESS') {
        _this.modal.content(res.data.html);
        _this.modal.contentDOM().data('tag', tag);
      } else if (res.msg === 'NOT_VALID') {
        app.viewWarningMessage();
      } else {
        app.viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  selectBatch: function selectBatch(batchProperty) {
    var _this = this;

    _this.modal.close(function () {
      var data = {};

      data.tag = _this.modal.contentDOM().data('tag');
      data.BatchProperty = batchProperty;

      $('body').trigger('warehouse-select-batch', data);
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.modal = services.get('modal-warehouse');

    _this.registerCallbacks();

    return _this;
  }
});
